module.exports = __webpack_public_path__ + "static/media/expired_coupon_1.f0aa1382.svg";